<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>

    <!-- START Page -->
    <div id="layout-wrapper">
      <TopBar :layoutscroll="layoutScrollable" />
      <SideBar />

      <div class="main-content" id="mainContent">
        <ScrollTop />
        <div class="page-content">
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <!--<Footer />-->
      </div>
    </div>
    <!-- END Page -->

  </div>
</template>

<script>
import router from '@/router';
import { layoutComputed } from '@/state/helpers';

import TopBar from '@/components/topbar';
import SideBar from '@/components/side-bar';
import Footer from '@/components/footer';

import ScrollTop from '@/components/scrollTop.vue';

export default {
  components: { TopBar, SideBar, Footer, ScrollTop },
  computed: {
    ...layoutComputed
  },
  data() {
    return {
      isMenuCondensed: false
    };
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = 'block';
      document.getElementById("status").style.display = 'block';
      setTimeout(function() {
        document.getElementById("preloader").style.display = 'none';
        document.getElementById("status").style.display = 'none';
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = 'none';
      document.getElementById("status").style.display = 'none';
    }
  },
  methods: {
    toggleMenu() {
      const currentSidebarSize = document.body.getAttribute("data-sidebar-size");
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });

        if (currentSidebarSize === null) {
          document.body.getAttribute("data-sidebar-size") === null ||
          document.body.getAttribute("data-sidebar-size") === 'lg'
              ? document.body.setAttribute("data-sidebar-size", "sm")
              : document.body.setAttribute("data-sidebar-size", "lg");
        } else if (currentSidebarSize === 'md') {
          document.body.getAttribute("data-sidebar-size") === 'md'
              ? document.body.setAttribute("data-sidebar-size", "sm")
              : document.body.setAttribute("data-sidebar-size", "md");
        } else {
          document.body.getAttribute("data-sidebar-size") === 'sm'
              ? document.body.setAttribute("data-sidebar-size", "lg")
              : document.body.setAttribute("data-sidebar-size", "sm");
        }
      } else {
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    }
  }
}
</script>
